import { Slider } from "@material-ui/core";
import { Text } from "grommet";
import styled from "styled-components";

export const thumbColors = [
  "#000094",
  "#0000b8",
  "#0000db",
  "#0000ff",
  "#3333ff",
  "#6666ff",
  "#9999ff",
  "#ccccff",
  "#ffffff",
  "#ffcccc",
  "#ff9999",
  "#ff6666",
  "#ff3333",
  "#ff0000",
  "#e60000",
  "#cc0000",
  "#b20000",
];

export const SliderNumber = styled(Text)`
  font-size: 12px;
  line-height: 1;
`;

export const StyledSlider = styled<any>(Slider)`
  .MuiSlider-track,
  .MuiSlider-rail {
    background: #706f6f;
  }
  .MuiSlider-thumb {
    background-color: ${(props: any) => props.background};
    box-shadow: 0 3px 1px 2px rgb(0 0 0 / 3%);
    border: 1px solid rgb(95 95 95 / 70%);
  }
`;
